import { Template } from "./template.js";

const Info_window = {
  components: {
    "ag-grid-vue": window.agGridVue.AgGridVue,
  },
  props: {
    selected: String,
  },
  data() {
    return {
      perPage: 60,
      periodDays: 10,
      startDate: this.getRangeDate(10),
      endDate: this.getRangeDate(1),
      periods: 60,
      dataPoints: [],
      dataPointsPressure: [],
      dateRanges: [
        {
          label: this.$t("modems.year"),
          value: 365,
        },
        {
          label: this.$t("modems.halfYear"),
          value: 183,
        },
        {
          label: this.$t("modems.days30"),
          value: 30,
        },
        {
          label: this.$t("modems.days10"),
          value: 10,
        },
        {
          label: this.$t("modems.days2"),
          value: 2,
        },
        {
          label: this.$t("modems.day1"),
          value: 1,
        },
      ],
      chartT: Object,
      chartP: Object,
    };
  },

  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },

  updated() {
    this.dateRanges[0].label = this.$t("modems.year");
    this.dateRanges[1].label = this.$t("modems.halfYear");
    this.dateRanges[2].label = this.$t("modems.days30");
    this.dateRanges[3].label = this.$t("modems.days10");
    this.dateRanges[4].label = this.$t("modems.days2");
    this.dateRanges[5].label = this.$t("modems.day1");
  },

  methods: {
    getRangeDate(days) {
      let date = new Date();
      date.setDate(date.getDate() - days + 1);
      return date.toISOString().slice(0, 10);
    },

    changeRange(days) {
      this.periodDays = days;
      this.startDate = this.getRangeDate(days);
      this.endDate = this.getRangeDate(1);
    },

    onDateRangeChange() {
      this.periodDays = null;
    },
    clearChart() {
      document.getElementById('chartContainerTemp').innerHTML='';
    },
    clearChartPressure() {
      document.getElementById('chartContainerPressure').innerHTML='';
    },
    getChartsData() {

      let periodBegin = new Date(this.startDate).getTime() / 1000;
      let periodEnd = new Date(this.endDate).getTime() / 1000 + 60 * 60 * 24;

      this.$API(
        "static_data",
        "onewire_t",
        {
          serial: this.selected,
          begin: periodBegin,
          end: periodEnd,
          periods: this.periods,
        },
        (data) => {
          console.log(data);
          if(!data.length){
            this.clearChart();
            return;
          }

          this.dataPoints = [];
          this.dataPointsPressure = [];

          this.fillChart(
              data,
              (periodBegin + new Date().getTimezoneOffset() * 60) * 1000,
              (periodEnd + new Date().getTimezoneOffset() * 60) * 1000,
              "chartContainerTemp",
              this.chartT
          );
        },
        function () {}
      );

      this.$API(
          "static_data",
          "onewire_p",
          {
            serial: this.selected,
            begin: periodBegin,
            end: periodEnd,
            periods: this.periods,
          },
          (data) => {
            console.log(data);
            if(!data.length){
              this.clearChartPressure();
              return;
            }
            this.fillChart(
                data,
                (periodBegin + new Date().getTimezoneOffset() * 60) * 1000,
                (periodEnd + new Date().getTimezoneOffset() * 60) * 1000,
                "chartContainerPressure",
                this.chartP
            );
          },
          function () {}
      );
    },
    fillChart(data, begin, end, containerID, chart) {
      var cont = this;

      data.some(function (el) {
        el.x = new Date(el.x * 1000);
      });
      cont.dataPoints = data;
      const axisYTemperature = {
            title: cont.$t("modems.temperature"),
            prefix: "",
            suffix: ` ${cont.$t("modems.temperatureUnit")}`,
            minimum: 0,
            //					maximum: 1800,
            includeZero: true,
          };
      const axisYPressure = {
        title: cont.$t("modems.pressure"),
        prefix: "",
        suffix: `${globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit}`,
        minimum: 0,
        //					maximum: 1800,
        includeZero: true,
      };
      //let interval = Math.round((end - begin) / 1000 / 60 / 60);
      CanvasJS.addCultureInfo("ru", {
        decimalSeparator: ".",
        digitGroupSeparator: ",",
        shortMonths: [
          "Янв",
          "Фев",
          "Мар",
          "Апр",
          "Май",
          "Июн",
          "Июл",
          "Авг",
          "Сен",
          "Окт",
          "Ноя",
          "Дек",
        ],
      });
      chart = new CanvasJS.Chart(containerID, {
        theme: "dark2", // "light2", "dark1", "dark2"
        animationEnabled: false, // change to true
        zoomEnabled: true,
        culture: cont.$i18n.locale === "ru" ? "ru" : "en",

        axisX: {
          //				valueFormatString: "DD/MM",
          minimum: begin,
          maximum: end,
          //				interval: interval,
          //				intervalType: "hour"
        },
        axisY: containerID==="chartContainerTemp" ? axisYTemperature : axisYPressure,
        //axisY: containerID==="chartContainerTemp" ? axisYTemperature : axisYTemperature,
        toolTip: {
          shared: true,
        },
        legend: {
          cursor: "pointer",
          verticalAlign: "bottom",
          horizontalAlign: "center",
          dockInsidePlotArea: false,
          itemclick: cont.toogleDataSeries,
        },
        data: [
          {
            type: "line", //spline
            axisYType: "primary",
            xValueType: "dateTime",
            xValueFormatString: "DD/MM/YYYY HH:mm",
            name: containerID==="chartContainerTemp" ? cont.$t("modems.onewire") : cont.$t("modems.onewireP"),
            showInLegend: true,
            color: "#ffff00",
            markerSize: 4,
            markerType: "circle",
            yValueFormatString: containerID==="chartContainerTemp" ? `#,##0.## ${cont.$t("modems.temperatureUnit")}` : `#,##0.##  ${globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit}`,
            connectNullData: false,
            dataPoints: cont.dataPoints,
          },
        ],
      });

      chart.render();
    },
  },
  watch: {
    locale() {
      this.getChartsData();
    },
    selected: {
      handler: function () {
        this.getChartsData();
      },

      immediate: true,
    },
    startDate() {
      this.getChartsData();
    },
    endDate() {
      this.getChartsData();
    },
  },
  template: Template,
};

export { Info_window };



// WEBPACK FOOTER //
// ./src/app/js/components/onewire/info_window/component.js